"use strict";

const AutoplayVideos = () => {
    const init = () => {
        $(function() {           
            var $autoplayVideos = $('.js-autoplay-video');

            if($autoplayVideos.length > 0 || $('.js-tabs-tab[data-video-class]').length)  {
                if(typeof YT === 'undefined' && typeof window.startedLoadingYT === 'undefined'){
                    window.startedLoadingYT = true;
                    $.getScript( "https://www.youtube.com/iframe_api", function( data, textStatus, jqxhr ) {
                        console.log( "Loaded Youtube API" );
                    });
                }
            }

            if($autoplayVideos.length > 0) {
                $(window).on('scroll', function(){
                    var found = false;
                    $autoplayVideos.each(function(){
                        if($(this).visible(true) && !found){
                            playVideo($(this), 1);
                            found = true;
                        }else if($(this).find('iframe').length){
                            $(this).append('<div class="autoplay-video-holder"></div>');
                            $(this).find('iframe').remove();
                        }
                    });
                });
                
                $autoplayVideos.on('click', function(){
                    playVideo($(this), 0);
                });
            }

            window.playVideo = function($this, muted) {
                if(typeof YT !== 'undefined'){
                    if($this.find('iframe').length <= 0){
                        new YT.Player($this.find('.autoplay-video-holder')[0], {
                            videoId: $this.data('video'),
                            playerVars: {
                                'playsinline': 1,
                                'mute': muted,
                                'rel': 0,
                                'start': $this.data('start') ? $this.data('start') : 0
                            },
                            events: {
                                'onReady': function(event) {
                                    event.target.playVideo();
                                },
                                'onStateChange': function(event) {
                                    if (event.data === YT.PlayerState.ENDED) {
                                        event.target.playVideo();
                                    }
                                }
                            }
                        });
                    }
                }else{
                    console.log('Youtube API not available');
                }
            }
        });
    };
    
    return {
        init:init
    };
};

export default AutoplayVideos;